import { makeStyles } from "@material-ui/core";
import React from "react";
import clsx from "clsx";

import { Brand } from "@ds-developer/models";
import { ErrorBoundary } from "@hubcapp/components";

import { AcceptancePageProps } from "./types";
import { Header } from "./components";

const useStyles = makeStyles(theme => ({
  root: {
    minHeight: "100vh",
    "&.aa": {
      background: "#f6f6f6",
    },
    "&.bsm": {
      background: "#F8F7F9",
    },
  },
  main: {
    margin: "40px 100px",
    [theme.breakpoints.down("sm")]: {
      margin: "20px 16px",
    },
  },
}));

const AcceptancePage: React.FC<AcceptancePageProps> = ({
  brand,
  headerTitle,
  children,
}) => {
  const classes = useStyles();
  return (
    <div className={clsx(classes.root, brand === Brand.Bsm ? "bsm" : "aa")}>
      <Header brand={brand} title={headerTitle}></Header>
      <main className={classes.main}>
        <ErrorBoundary>{children}</ErrorBoundary>
      </main>
    </div>
  );
};

export default AcceptancePage;
